jQuery(function () {
    var startPage = $('.start-page').length > 0;
    if (!startPage) {
        return;
    }
    var topMargin = 72;
    $('.js-start-page-navigation-btn').on('click', function () {
        var anchorLink = $(this).data('anchor-btn');
        var anchor = $('body').find('[data-anchor="' + anchorLink + '"]');
        var anchorOffset = anchor.offset().top - topMargin;
        $('html,body').animate({ scrollTop: anchorOffset }, 1000);
    });
    $('.start-page-banner').on('click', function (e) {
        var closeBtn = $('.start-page-banner__close');
        if (!closeBtn.is(e.target) && closeBtn.has(e.target).length === 0) {
            var anchor = $('body').find('[data-anchor="campaign"]');
            var anchorOffset = anchor.offset().top - topMargin;
            $('html,body').animate({ scrollTop: anchorOffset }, 1000);
        }
        else {
            $(this).slideUp();
        }
        registerSeenCampaigns();
    });
    function registerSeenCampaigns() {
        $.ajax({
            url: '/kampanjer/register-seen-campaigns',
            method: 'POST'
        });
    }
});
